<template>
  <div>
    <!-- Approve START -->
    <v-dialog persistent v-model="approveModal" max-width="1000">
      <v-card>
        <v-card-title class="headline indigo lighten-2">
          <div class="text-center white--text" style="width: 100%">
            {{ $t('title.juryScore') }}
          </div>
        </v-card-title>
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(sendForm)">
            <v-card-text class="pt-4 text-center d-flex justify-center">
              <div class="text-center" style="width: 100% !important">
                <v-card-title>
            <span>Fikir Detayı</span>
          </v-card-title>
                <v-text-field
                  v-model="idea.InnovationTitle"
                  label="Inovasyon Başlığı"
                  disabled
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="idea.IdeaItems[0].Title"
                  disabled
                  label="Fikir Başlığı"
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="idea.IdeaItems[0].Description"
                  disabled
                  label="Fikir Açıklamamsı"
                  outlined
                ></v-text-field>
                <v-card-title>
            <span>Kriterler</span>
          </v-card-title>
                <div v-for="item in criterias" :key="item.Id">
                  <v-text-field
                    v-model="item.Score"
                    outlined
                    :disabled="item.disabled"
                    :label="item.Name"
                    type="number"
                  >
                  </v-text-field>
                </div>

                <v-btn
                  small
                  class="ma-2 mr-4"
                  elevation="0"
                  large
                  outlined
                  color="grey"
                  @click="approveModal = false"
                >
                  {{ $t("buttons.cancel") }}
                </v-btn>
                <v-btn
                  small
                  class="ma-2 mr-4"
                  elevation="0"
                  large
                  outlined
                  :disabled="checkDisable"
                  color="green"
                  type="submit"
                >
                  Puanla
                </v-btn>
              </div>
            </v-card-text>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <!-- Approve END -->
    <!-- Emergency deletion modal -->
    <delete-modal :yesFunc="deleteItem" ref="deleteModalRef" />
    <!-- Page content -->
    <v-card style="border-radius: 10px">
      <v-card-title style="color: #595959">
        <v-row>
          <v-col class="py-2">{{ $t("title.IdeaScore") }}</v-col>
          <v-spacer />
        </v-row>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4"
        ><v-row justify="space-between">
          <v-col cols="2">
            <v-select
              v-model="itemsPerPage"
              :items="perPageValues"
              :label="$t('labels.selectItemsPerPage')"
              item-value="value"
              item-text="name"
              @change="changeItemsPerPage()"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="tableData"
          :loading="loadings.table"
          :options.sync="options"
          :hide-default-footer="true"
          :footer-props="{
            disablePagination: true,
            disableItemsPerPage: true,
          }"
          :no-data-text="$t('description.noList')"
        >
          <!-- eslint-disable -->

          <template v-slot:item.Title="{ item }">
            {{ item.IdeaItems[0].Title }}
          </template>
          <template v-slot:item.Type="{ item }">
            <v-chip
              v-if="item.Type == 2"
              class="ma-2"
              small
              color="green"
              text-color="white"
            >
              Takım
            </v-chip>
            <v-chip
              v-if="item.Type == 0"
              class="ma-2"
              small
              color="orange"
              text-color="white"
            >
              {{ $t("labels.anonim") }}
            </v-chip>
            <v-chip
              v-if="item.Type == 1"
              class="ma-2"
              small
              color="orange"
              text-color="white"
            >
              Bireysel
            </v-chip>
          </template>
          

          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="openScoreDialog(item.Id)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Puanla</span>
            </v-tooltip>
            <v-tooltip top v-if="item.IdeaItems[0].FileIds.length != 0">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="downloadFile(item.IdeaItems[0].FileIds[0])"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>Dosyayı Gör</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2 md4 lg4">
          <v-pagination
            @input="paginationChangeHandler"
            :value="pagination.page"
            :length="pages"
            :total-visible="10"
            circle
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import InnovationService from "../services/InnovationService";
import IdeaService from "../services/IdeaService";
import DeleteModal from "../components/General/DeleteModal";
export default {
  data: () => ({
    checkDisable:false,
    // List options
    approveModal: false,
    criterias: [],
    idea: {},
    options: {
      itemsPerPage: 15,
    },
    top: 15,
    skip: 0,
    tableData: [],
    headers: [],
    //Loading states
    loadings: {
      table: false,
      select: false,
      send: false,
    },
    modalHeader: "", //Global header for opened modal
    //Group

    //Pagination models
    pagination: {},
    itemsPerPage: 15,
    perPageValues: [10, 15, 30, 50, 100],
  }),

  watch: {},
  mounted() {
    this.setup();
    this.getTableList();
  },
  components: {
    DeleteModal,
  },

  computed: {
    totalRecords() {
      return this.items.length;
    },
    pageCount() {
      return this.totalRecords / this.itemsPerPage;
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },

  methods: {
    setup() {
      this.headers = [
        {
          text: this.$t("title.Innovation"),
          value: "InnovationTitle",
          sortable: false,
        },
        {
          text: this.$t("title.JoinType"),
          value: "Type",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderLikeCount"),
          value: "LikeCount",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderIdeaTitle"),
          value: "Title",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderActions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
        (this.pagination = {
          totalItems: 200,
          rowsPerPage: this.itemsPerPage,
          page: 1,
        }),
      ];
    },
    //Fill's the emergency list
    getTableList() {
      this.$store.state.loadingStatus = true;
        this.tableData=[];
      IdeaService.getIdeasForJury(
        this.pagination.page,
        this.pagination.rowsPerPage
      )
        .then((res) => {
          this.tableData = res.data.Result;
          this.idea = this.tableData;
          console.log("idea", this.idea);
          this.pagination.totalItems = res.data.TotalItems;
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    goDetail(id) {
      this.$router.push({
        name: `innovationManagement`,
        query: { id },
      });
    },

    getMarkerIcon(item) {
      if (item.SafetyStatus === 1)
        return require("../../public/img/PersonInDanger.png");
      else {
        return require("../../public/img/PersonNotInDanger.png");
      }
    },

    openMarkerInfo(item) {
      this.selectedMarker = item;
      this.markerModalShow = true;
    },

    getTitleColor(item) {
      if (item.SafetyStatus === 0) return "green";
      else {
        return "error";
      }
    },

    downloadFile(url) {
      window.open(url, "_blank");
    },

    clearModal() {},

 
    //Opens modal for deletion operation
    openDeleteModal(item) {
      this.deleteItemModel = item;
      this.$refs.deleteModalRef.modalStatus = true;
    },
    sendForm() {
      console.log("criterrer", this.criterias);

      this.criterias.forEach((element) => {
        if (element.disabled == false) {
          bodyIsNull=false;
          let body = {
            CriterionId: element.Id,
            Score: element.Score,
            IdeaId: this.idea.Id,
          };
          console.log("bodyIsNull", bodyIsNull);
          this.$store.state.loadingStatus = true;
          InnovationService.giveScoreToIdea(body)
            .then((res) => {
              this.approveModal=false;
            })
            .catch((err) => {
              window.showInfo(
                this.$t("description.emergencyDownloadError"),
                "standart",
                "info"
              );
            })
            .then(() => {
              this.$store.state.loadingStatus = false;
              this.getTableList();
            });
        }
        
      });
      this.approveModal=false;
    },
    
    openScoreDialog(id) {
      this.$store.state.loadingStatus = true;
      this.idea = {};
      this.criterias=[];
      this.idea = this.tableData.find((item) => item.Id == id);
      this.approveModal = true;
      InnovationService.getInnovationCriterias(this.idea.InnovationId)
        .then((res) => {
          res.data.forEach((element) => {
            let obj = {
              Id: element.Id,
              Name: element.Name,
              Score: null,
              disabled: false,
            };
            var juryScore = this.idea.JuriesScores.find(
              (x) => x.CriterionId == obj.Id
            );
            if (juryScore != null) {
              obj.Score = juryScore.Score;
              obj.disabled = true;
            }
            this.criterias.push(obj);
            var findDisable = this.criterias.find(
              (x) => x.disabled == false
            );
            if(findDisable==null){
              this.checkDisable=true;
            }else{
              this.checkDisable=false;
            }
          });
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    //Change displayed items per page, page number one is default
    changeItemsPerPage() {
      this.pagination.rowsPerPage = this.itemsPerPage;
      this.pagination.page = 1;
      this.options.itemsPerPage = this.itemsPerPage;
      this.getTableList();
    },

    //Change list pagination page
    paginationChangeHandler(pageNumber) {
      this.pagination.page = pageNumber;
      this.getTableList();
    },
  },
};
</script>
